export default __webpack_public_path__ + "static/media/AIIB_full_logo.991a7705.svg";